// ─── Qué muestra «Historial» en el portal del alumno (puro, con test) ───────
// Con `graduation_audit`, el expediente: lo cursado con su nota, sus créditos
// y el avance de cada credencial (el mismo cálculo que ve el personal). Sin el
// flag, la página de siempre, sin un cambio. Mientras no se sabe si el flag
// está encendido, se espera: mostrar una y después la otra sería un parpadeo.

export type HistorialView = 'loading' | 'record' | 'legacy';

export function historialView(input: {
  settled: boolean;
  credentialRecord: boolean;
}): HistorialView {
  if (!input.settled) return 'loading';
  return input.credentialRecord ? 'record' : 'legacy';
}
